









































































































import Vue from 'vue'
import { StatsEditData } from '../types'
import { regexGeneralHumanIdentifier } from '@morpheus/utils/admin-vue/helpers/regex'

export default Vue.extend({
  name: 'UserStatsEditForm',
  props: {
    formId: {
      required: true,
      type: String
    },
    triggerClear: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      regex: {
        code: regexGeneralHumanIdentifier
      },
      items: [
        {
          code: '',
          value: null
        }
      ]
    }
  },
  watch: {
    triggerClear (val: boolean) {
      if (val) {
        this.clearEditForm()
      }
    }
  },
  methods: {
    addStat () {
      this.items.push({ code: '', value: null })
    },
    deleteStat (index: number) {
      this.items.splice(index, 1)
    },
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            const requestObj:StatsEditData = {}
            this.items.forEach((stat: any) => {
              requestObj[stat.code] = { value: +stat.value }
            })
            this.$emit('onSubmit', requestObj)
          }
        })
    },
    cancel () {
      this.$emit('closeDialog')
      this.clearEditForm()
    },
    clearEditForm () {
      this.$validator.reset()
      this.$emit('closeDialog')
      this.items = [{ code: '', value: null }]
    }
  }
})
